import { createAction, handleActions } from 'redux-actions'

const setSubInvoices = createAction('SCREENS/SUB_PROJECT/SUB_INVOICES/SET_SUB_INVOICES')
const resetSubInvoices = createAction('SCREENS/SUB_PROJECT/SUB_INVOICES/RESET_SUB_INVOICES')

const defaultState = []

const reducer = handleActions(
  {
    [setSubInvoices]: (state, { payload }) => payload,
    [resetSubInvoices]: () => defaultState,
  },
  defaultState,
)

export { setSubInvoices, resetSubInvoices, reducer }
